(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5099],{

/***/ 11802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CustomWidgetFilters; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/ForCWV/CustomCategoryPage/category.module.scss
var category_module = __webpack_require__(14911);
var category_module_default = /*#__PURE__*/__webpack_require__.n(category_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./svg/index.js
var svg = __webpack_require__(69587);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(81043);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/ForCWV/CustomCategoryPage/helpers.ts
var helpers = __webpack_require__(49919);
;// CONCATENATED MODULE: ./components/ForCWV/CustomCategoryPage/CustomFilterCheck.tsx













var ListItemLabel = function(param) {
    var item = param.item, checked = param.checked, code = param.code;
    var router = (0,next_router.useRouter)();
    var itemDisabledCls = function() {
        if (!item.count) return "";
        return (category_module_default())["filter-list__item--disabled"];
    }();
    var isCheckedItem = function() {
        if (!checked) return "";
        return (category_module_default()).checked;
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
        className: "".concat((category_module_default())["filter-list__item"], " ").concat((category_module_default()).checkbox__item, " ").concat(itemDisabledCls),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((category_module_default())["filter-list__input"], " ").concat((category_module_default())["input-check"]),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (category_module_default())["input-check__body"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            className: (category_module_default())["input-check__input"],
                            type: "checkbox",
                            value: item.id,
                            checked: checked,
                            disabled: item.count === 0,
                            onChange: function(e) {
                                return (0,helpers/* handleFilterChange */.G)(e, router, code);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (category_module_default())["input-check__box"]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* Check9x7Svg */.rM, {
                            className: (category_module_default())["input-check__icon"]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "".concat((category_module_default())["filter-list__title"], " ").concat(isCheckedItem),
                    children: item.label
                })
            ]
        })
    });
};
var CustomFilterCheck = function(param) {
    var _data = param.data, data = _data === void 0 ? [] : _data, value = param.value, title = param.title;
    var ref, ref1, ref2, ref3;
    var ref4 = value || {}, tmp = ref4.attributes, ref5 = (0,_sliced_to_array/* default */.Z)(tmp === void 0 ? [] : tmp, 1), tmp1 = ref5[0], ref6 = tmp1 === void 0 ? {} : tmp1, _code = ref6.code, code = _code === void 0 ? "" : _code;
    var sidebarOpen = (0,es/* useSelector */.v9)(function(state) {
        return state.sidebar.open;
    });
    var ref7 = (0,react.useState)(false), filterListHeight = ref7[0], setFilterListHeight = ref7[1];
    var checkRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var isOpen = ((ref2 = (ref1 = (ref = router.query) === null || ref === void 0 ? void 0 : ref.open_dd) === null || ref1 === void 0 ? void 0 : ref1.split(",")) === null || ref2 === void 0 ? void 0 : ref2.some(function(ii) {
        return ii === title;
    })) || false;
    (0,react.useEffect)(function() {
        var ref;
        if (!filterListHeight && ((ref = checkRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight)) {
            var ref1;
            setFilterListHeight(((ref1 = checkRef.current) === null || ref1 === void 0 ? void 0 : ref1.clientHeight) > 88);
        }
    }, [
        (ref3 = checkRef.current) === null || ref3 === void 0 ? void 0 : ref3.clientHeight,
        sidebarOpen
    ]);
    var toggleOpen = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, ref3, queryObj, ref4, ref5, existTitlesDD, ref6;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!((ref2 = (ref1 = (ref = router.query) === null || ref === void 0 ? void 0 : ref.open_dd) === null || ref1 === void 0 ? void 0 : ref1.split(",")) === null || ref2 === void 0 ? void 0 : ref2.some(function(elem) {
                            return elem === title;
                        }))) return [
                            3,
                            2
                        ];
                        queryObj = router.query || {};
                        if (((ref3 = queryObj.open_dd) === null || ref3 === void 0 ? void 0 : ref3.split(",").length) === 1) {
                            delete queryObj.open_dd;
                        } else {
                            ;
                            queryObj.open_dd = (ref4 = queryObj.open_dd) === null || ref4 === void 0 ? void 0 : ref4.split(",").filter(function(item) {
                                return item !== title;
                            }).join(",");
                        }
                        return [
                            4,
                            router.push({
                                query: queryObj
                            }, undefined, {
                                scroll: false
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        existTitlesDD = [
                            title
                        ];
                        if ((ref5 = router.query) === null || ref5 === void 0 ? void 0 : ref5.open_dd) {
                            ;
                            existTitlesDD = (0,_to_consumable_array/* default */.Z)(((ref6 = router.query) === null || ref6 === void 0 ? void 0 : ref6.open_dd).split(",")).concat([
                                title
                            ]);
                        }
                        return [
                            4,
                            router.push({
                                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                                    open_dd: existTitlesDD.join(",")
                                })
                            }, undefined, {
                                scroll: false
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function toggleOpen() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((category_module_default())["filter-list"], " ").concat(!isOpen && filterListHeight ? (category_module_default())["filter-list__closed"] : ""),
        ref: checkRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (category_module_default()).widget__title,
                onClick: toggleOpen,
                children: [
                    title,
                    filterListHeight && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "".concat((category_module_default()).filter__item, " ").concat(isOpen && (category_module_default()).open),
                        type: "button",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* ArrowRoundedDown12x7Svg */.bD, {
                            className: (category_module_default())["mobile-links__item-arrow"]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (category_module_default())["filter-list__list"],
                children: data === null || data === void 0 ? void 0 : data.map(function(item, index) {
                    var ref;
                    var checked = String((ref = router.query) === null || ref === void 0 ? void 0 : ref["filter_".concat(code)]).split(",").some(function(elem) {
                        return elem === String(item.id);
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemLabel, {
                        checked: checked,
                        code: code,
                        item: item
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var CustomCategoryPage_CustomFilterCheck = (CustomFilterCheck);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./components/ForCWV/CustomCategoryPage/CustomFilterMultiSelect.tsx














var CustomFilterMultiSelect_ListItemLabel = function(param) {
    var item = param.item, checked = param.checked, code = param.code;
    var router = (0,next_router.useRouter)();
    var itemDisabledCls = function() {
        if (!item.count) return "";
        return (category_module_default())["filter-list__item--disabled"];
    }();
    var isCheckedItem = function() {
        if (!checked) return "";
        return (category_module_default()).checked;
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
        className: "".concat((category_module_default())["filter-list__item"], " ").concat((category_module_default()).multiselect__item, " ").concat(itemDisabledCls),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((category_module_default())["filter-list__input"], " ").concat((category_module_default())["input-check"]),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (category_module_default())["input-check__body"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            className: (category_module_default())["input-check__input"],
                            type: "checkbox",
                            value: item.id,
                            checked: checked,
                            disabled: item.count === 0,
                            onChange: function(e) {
                                return (0,helpers/* handleFilterChange */.G)(e, router, code);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (category_module_default())["input-check__box"]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* Check9x7Svg */.rM, {
                            className: (category_module_default())["input-check__icon"]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "".concat((category_module_default())["filter-list__title"], " ").concat(isCheckedItem),
                    children: item.label
                })
            ]
        })
    });
};
var CustomFilterMultiSelect = function(param) {
    var _data = param.data, data = _data === void 0 ? [] : _data, value = param.value, title = param.title, translationsData = param.translationsData;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = value || {}, tmp = ref5.attributes, ref6 = (0,_sliced_to_array/* default */.Z)(tmp === void 0 ? [] : tmp, 1), tmp1 = ref6[0], ref7 = tmp1 === void 0 ? {} : tmp1, _code = ref7.code, code = _code === void 0 ? "" : _code;
    var sidebarOpen = (0,es/* useSelector */.v9)(function(state) {
        return state.sidebar.open;
    });
    var ref8 = (0,react.useState)(false), filterListHeight = ref8[0], setFilterListHeight = ref8[1];
    var checkRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var isOpen = ((ref2 = (ref1 = (ref = router.query) === null || ref === void 0 ? void 0 : ref.open_dd) === null || ref1 === void 0 ? void 0 : ref1.split(",")) === null || ref2 === void 0 ? void 0 : ref2.some(function(ii) {
        return ii === title;
    })) || false;
    var selectedIds = String(((ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3["filter_".concat(code)]) || "").split(",").filter(Boolean);
    var selectedItems = data.filter(function(item) {
        return selectedIds.includes(String(item.id));
    });
    (0,react.useEffect)(function() {
        var ref;
        if (!filterListHeight && ((ref = checkRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight)) {
            var ref1;
            setFilterListHeight(((ref1 = checkRef.current) === null || ref1 === void 0 ? void 0 : ref1.clientHeight) > 88);
        }
    }, [
        (ref4 = checkRef.current) === null || ref4 === void 0 ? void 0 : ref4.clientHeight,
        sidebarOpen
    ]);
    var toggleOpen = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, ref3, queryObj, ref4, ref5, existTitlesDD, ref6;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!((ref2 = (ref1 = (ref = router.query) === null || ref === void 0 ? void 0 : ref.open_dd) === null || ref1 === void 0 ? void 0 : ref1.split(",")) === null || ref2 === void 0 ? void 0 : ref2.some(function(elem) {
                            return elem === title;
                        }))) return [
                            3,
                            2
                        ];
                        queryObj = router.query || {};
                        if (((ref3 = queryObj.open_dd) === null || ref3 === void 0 ? void 0 : ref3.split(",").length) === 1) {
                            delete queryObj.open_dd;
                        } else {
                            ;
                            queryObj.open_dd = (ref4 = queryObj.open_dd) === null || ref4 === void 0 ? void 0 : ref4.split(",").filter(function(item) {
                                return item !== title;
                            }).join(",");
                        }
                        return [
                            4,
                            router.push({
                                query: queryObj
                            }, undefined, {
                                scroll: false
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        existTitlesDD = [
                            title
                        ];
                        if ((ref5 = router.query) === null || ref5 === void 0 ? void 0 : ref5.open_dd) {
                            ;
                            existTitlesDD = (0,_to_consumable_array/* default */.Z)(((ref6 = router.query) === null || ref6 === void 0 ? void 0 : ref6.open_dd).split(",")).concat([
                                title
                            ]);
                        }
                        return [
                            4,
                            router.push({
                                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                                    open_dd: existTitlesDD.join(",")
                                })
                            }, undefined, {
                                scroll: false
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function toggleOpen() {
            return _ref.apply(this, arguments);
        };
    }();
    var removeSelectedItem = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(itemId) {
            var ref, currentFilter, newFilter, newQuery;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        currentFilter = String(((ref = router.query) === null || ref === void 0 ? void 0 : ref["filter_".concat(code)]) || "").split(",").filter(Boolean);
                        newFilter = currentFilter.filter(function(id) {
                            return id !== String(itemId);
                        });
                        newQuery = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), (0,_define_property/* default */.Z)({}, "filter_".concat(code), newFilter.join(",")));
                        if (!newFilter.length) {
                            delete newQuery["filter_".concat(code)];
                        }
                        return [
                            4,
                            router.push({
                                query: newQuery
                            }, undefined, {
                                scroll: false
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function removeSelectedItem(itemId) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((category_module_default())["filter-list"], " ").concat(!isOpen && filterListHeight ? (category_module_default())["filter-list__closed"] : ""),
        ref: checkRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((category_module_default()).widget__title, " ").concat((category_module_default()).multiselect__title),
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (category_module_default()).widget__field,
                onClick: toggleOpen,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (category_module_default()).selected__items,
                        children: selectedItems.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (category_module_default()).placeholder,
                            children: translationsData.ChooseOption
                        }) : selectedItems.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (category_module_default()).selected__item,
                                onClick: function(e) {
                                    e.stopPropagation();
                                    removeSelectedItem(item.id);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (category_module_default()).item,
                                        children: item.label
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* CloseSvg */.sZ, {})
                                ]
                            }, index);
                        })
                    }),
                    filterListHeight && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "".concat((category_module_default()).filter__item, " ").concat(isOpen && (category_module_default()).open),
                        type: "button",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* ArrowRoundedDown12x7Svg */.bD, {
                            className: (category_module_default())["mobile-links__item-arrow"]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (category_module_default())["filter-multiselect__list"],
                children: data === null || data === void 0 ? void 0 : data.map(function(item, index) {
                    var ref;
                    var checked = String((ref = router.query) === null || ref === void 0 ? void 0 : ref["filter_".concat(code)]).split(",").some(function(elem) {
                        return elem === String(item.id);
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomFilterMultiSelect_ListItemLabel, {
                        checked: checked,
                        code: code,
                        item: item
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var CustomCategoryPage_CustomFilterMultiSelect = (CustomFilterMultiSelect);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./components/ForCWV/CustomCategoryPage/CustomFilterSelect.tsx














var CustomFilterSelect = function(param) {
    var _data = param.data, data = _data === void 0 ? [] : _data, value = param.value, title = param.title, translationsData = param.translationsData;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = value || {}, tmp = ref5.attributes, ref6 = (0,_sliced_to_array/* default */.Z)(tmp === void 0 ? [] : tmp, 1), tmp1 = ref6[0], ref7 = tmp1 === void 0 ? {} : tmp1, _code = ref7.code, code = _code === void 0 ? "" : _code;
    var sidebarOpen = (0,es/* useSelector */.v9)(function(state) {
        return state.sidebar.open;
    });
    var ref8 = (0,react.useState)(false), filterListHeight = ref8[0], setFilterListHeight = ref8[1];
    var checkRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var isOpen = ((ref2 = (ref1 = (ref = router.query) === null || ref === void 0 ? void 0 : ref.open_dd) === null || ref1 === void 0 ? void 0 : ref1.split(",")) === null || ref2 === void 0 ? void 0 : ref2.includes(title)) || false;
    var selectedId = String(((ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3["filter_".concat(code)]) || "");
    var selectedItem = data.find(function(item) {
        return String(item.id) === selectedId;
    });
    (0,react.useEffect)(function() {
        var ref;
        if (!filterListHeight && ((ref = checkRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight)) {
            var ref1;
            setFilterListHeight(((ref1 = checkRef.current) === null || ref1 === void 0 ? void 0 : ref1.clientHeight) > 88);
        }
    }, [
        (ref4 = checkRef.current) === null || ref4 === void 0 ? void 0 : ref4.clientHeight,
        sidebarOpen
    ]);
    var toggleOpen = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, currentOpen, updated, _query, open_dd, rest;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        currentOpen = ((ref1 = (ref = router.query) === null || ref === void 0 ? void 0 : ref.open_dd) === null || ref1 === void 0 ? void 0 : ref1.split(",")) || [];
                        updated = currentOpen.includes(title) ? currentOpen.filter(function(item) {
                            return item !== title;
                        }) : (0,_to_consumable_array/* default */.Z)(currentOpen).concat([
                            title
                        ]);
                        if (!(updated.length === 0)) return [
                            3,
                            2
                        ];
                        _query = router.query, open_dd = _query.open_dd, rest = (0,_object_without_properties/* default */.Z)(_query, [
                            "open_dd"
                        ]);
                        return [
                            4,
                            router.push({
                                query: rest
                            }, undefined, {
                                scroll: false
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            router.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router), {
                                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                                    open_dd: updated.join(",")
                                })
                            }), undefined, {
                                scroll: false
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function toggleOpen() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSelect = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var ref, ref1, _query, page, routerQuery, currentOpen, updated, newQuery;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _query = router.query, page = _query.page, routerQuery = (0,_object_without_properties/* default */.Z)(_query, [
                            "page"
                        ]);
                        currentOpen = ((ref1 = (ref = router.query) === null || ref === void 0 ? void 0 : ref.open_dd) === null || ref1 === void 0 ? void 0 : ref1.split(",")) || [];
                        updated = currentOpen.filter(function(item) {
                            return item !== title;
                        });
                        newQuery = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, routerQuery), (0,_define_property/* default */.Z)({}, "filter_".concat(code), id));
                        if (router.query["filter_".concat(code)] === "".concat(id)) {
                            delete newQuery["filter_".concat(code)];
                        }
                        if (updated.length === 0) {
                            delete newQuery.open_dd;
                        } else {
                            newQuery.open_dd = updated.join(",");
                        }
                        return [
                            4,
                            router.push({
                                query: newQuery
                            }, undefined, {
                                scroll: false
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSelect(id) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((category_module_default())["filter-list"], " ").concat(!isOpen && filterListHeight ? (category_module_default())["filter-list__closed"] : ""),
        ref: checkRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((category_module_default()).widget__title, " ").concat((category_module_default()).select__title),
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((category_module_default()).widget__field, " ").concat((category_module_default()).select__filter),
                onClick: toggleOpen,
                children: [
                    !selectedItem ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (category_module_default()).placeholder,
                        children: translationsData.ChooseOption
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (category_module_default()).selected__item,
                        children: selectedItem.label
                    }),
                    data.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "".concat((category_module_default()).filter__item, " ").concat(isOpen && (category_module_default()).open),
                        type: "button",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* ArrowRoundedDown12x7Svg */.bD, {
                            className: (category_module_default())["mobile-links__item-arrow"]
                        })
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((category_module_default())["filter-select__list"], " ").concat((category_module_default()).select_filter__options),
                children: data.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((category_module_default())["filter-list__item"], " ").concat(String(item.id) === selectedId ? (category_module_default()).selected__option : ""),
                        onClick: function() {
                            return handleSelect(String(item.id));
                        },
                        children: item.label
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var CustomCategoryPage_CustomFilterSelect = (CustomFilterSelect);

// EXTERNAL MODULE: ./node_modules/react-input-range/lib/js/index.js
var js = __webpack_require__(9322);
var js_default = /*#__PURE__*/__webpack_require__.n(js);
// EXTERNAL MODULE: ./hooks/useDebounce.js
var useDebounce = __webpack_require__(1601);
;// CONCATENATED MODULE: ./components/ForCWV/CustomCategoryPage/CustomFilterRange.tsx












var CustomFilterRange = function(param) {
    var tmp = param.data, ref = tmp === void 0 ? {
        min: 0,
        max: 0
    } : tmp, min = ref.min, max = ref.max, title = param.title, tmp1 = param.selectedRate, ref1 = tmp1 === void 0 ? {} : tmp1, tmp2 = ref1.symbol, selectedCurrSymbol = tmp2 === void 0 ? "" : tmp2;
    var _ref = (0,next_router.useRouter)(), _query = _ref.query, _filter_price = _query.filter_price, filter_price = _filter_price === void 0 ? "".concat(min, ",").concat(max) : _filter_price, page = _query.page, routerPush = _ref.push, otherQuery = (0,_object_without_properties/* default */.Z)(_ref.query, [
        "filter_price",
        "page"
    ]);
    var priceRange = String(filter_price).split(",").map(Number);
    var safeFrom = !isNaN(priceRange[0]) ? priceRange[0] : min;
    var safeTo = !isNaN(priceRange[1]) ? priceRange[1] : max;
    var ref2 = (0,react.useState)([
        safeFrom.toString(),
        safeTo.toString()
    ]), ref3 = (0,_sliced_to_array/* default */.Z)(ref2[0], 2), stateFrom = ref3[0], stateTo = ref3[1], setState = ref2[1];
    var debouncedUpdate = (0,useDebounce/* default */.Z)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(newMin, newMax) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            routerPush({
                                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherQuery), {
                                    filter_price: "".concat(newMin, ",").concat(newMax)
                                })
                            }, undefined, {
                                scroll: false
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(newMin, newMax) {
            return _ref.apply(this, arguments);
        };
    }(), 1000);
    var handleChange = function(param) {
        var newFrom = param.min, newTo = param.max;
        setState([
            newFrom.toString(),
            newTo.toString()
        ]);
    };
    var handleCompleteChange = function(param) {
        var newFrom = param.min, newTo = param.max;
        debouncedUpdate(newFrom, newTo);
    };
    var handleInputChange = function(e, type) {
        var ref = e || {}, value = ref.target.value;
        var debounceInfoHandle = function(array) {
            var _array = (0,_sliced_to_array/* default */.Z)(array, 2), insideMin = _array[0], insideMax = _array[1];
            setState(array);
            var parsedMin = parseInt(insideMin) || min;
            var parsedMax = parseInt(insideMax) || max;
            debouncedUpdate(parsedMin, parsedMax);
        };
        debounceInfoHandle(type === "min" ? [
            value,
            stateTo
        ] : [
            stateFrom,
            value
        ]);
    };
    var handleInputBlur = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var newMin, newMax;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        newMin = parseInt(stateFrom) || min;
                        newMax = parseInt(stateTo) || max;
                        setState([
                            newMin.toString(),
                            newMax.toString()
                        ]);
                        return [
                            4,
                            routerPush({
                                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherQuery), {
                                    filter_price: "".concat(newMin, ",").concat(newMax)
                                })
                            }, undefined, {
                                scroll: false
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleInputBlur() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (category_module_default())["filter-price"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (category_module_default()).widget__title,
                children: title
            }),
            max ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((category_module_default())["filter-price__slider"], " ").concat(min === max ? (category_module_default()).same_min_max : ""),
                        dir: "ltr",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((js_default()), {
                            minValue: min,
                            maxValue: max,
                            value: {
                                min: parseInt(stateFrom) || min,
                                max: parseInt(stateTo) || max
                            },
                            step: 1,
                            onChange: handleChange,
                            onChangeComplete: handleCompleteChange
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((category_module_default())["filter-price__inputs"], " ").concat(min === max ? (category_module_default()).same_min_max : ""),
                        dir: "ltr",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (category_module_default()).input__container,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: selectedCurrSymbol
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "text",
                                        value: stateFrom,
                                        placeholder: "Min",
                                        onChange: function(e) {
                                            return handleInputChange(e, "min");
                                        },
                                        onBlur: handleInputBlur
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (category_module_default()).input__container,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: selectedCurrSymbol
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "text",
                                        value: stateTo,
                                        placeholder: "Max",
                                        onChange: function(e) {
                                            return handleInputChange(e, "max");
                                        },
                                        onBlur: handleInputBlur
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : null
        ]
    });
};
/* harmony default export */ var CustomCategoryPage_CustomFilterRange = (CustomFilterRange);

;// CONCATENATED MODULE: ./components/ForCWV/CustomCategoryPage/CustomFilterColor.tsx








var CustomFilterColor = function(param) {
    var data = param.data, _value = param.value, tmp = _value.attributes, ref = (0,_sliced_to_array/* default */.Z)(tmp === void 0 ? [] : tmp, 1), ref1 = ref[0], _code = ref1.code, code = _code === void 0 ? "" : _code, title = param.title;
    var ref2;
    var sidebarOpen = (0,es/* useSelector */.v9)(function(state) {
        return state.sidebar.open;
    });
    var ref3 = (0,react.useState)(false), isOpen = ref3[0], setIsOpen = ref3[1];
    var ref4 = (0,react.useState)(false), filterListHeight = ref4[0], setFilterListHeight = ref4[1];
    var checkRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        if (!filterListHeight) {
            var ref;
            setFilterListHeight(((ref = checkRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight) > 88);
        }
    }, [
        (ref2 = checkRef.current) === null || ref2 === void 0 ? void 0 : ref2.clientHeight,
        sidebarOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((category_module_default())["filter-list"], " ").concat(!isOpen && filterListHeight ? (category_module_default())["filter-list__closed"] : ""),
        ref: checkRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (category_module_default()).widget__title,
                onClick: function() {
                    if (filterListHeight) {
                        setIsOpen(function(prevState) {
                            return !prevState;
                        });
                    }
                },
                children: [
                    title,
                    filterListHeight ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "".concat((category_module_default()).filter__item, " ").concat(isOpen && (category_module_default()).open),
                        type: "button",
                        onClick: function() {
                            return setIsOpen(function(prevState) {
                                return prevState;
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* ArrowRoundedDown12x7Svg */.bD, {
                            className: (category_module_default())["mobile-links__item-arrow"]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (category_module_default())["filter-color__list"],
                children: data === null || data === void 0 ? void 0 : data.map(function(item, index) {
                    var ref;
                    var checked = String((ref = router.query) === null || ref === void 0 ? void 0 : ref["filter_".concat(code)]).split(",").some(function(elem) {
                        return elem === String(item.id);
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (category_module_default())["filter-color__item"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "\n                                    ".concat((category_module_default())["filter-color__check"], "\n                                    ").concat((category_module_default())["input-check-color"], "\n                                    ").concat((category_module_default())["input-check-color--".concat(item.stringifyColorType.toLowerCase())], "\n                                "),
                            style: {
                                color: item.swatch_value || "".concat(item.admin_name).toLowerCase()
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                className: (category_module_default())["input-check-color__body"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        className: (category_module_default())["input-check-color__input"],
                                        type: "checkbox",
                                        value: item.id,
                                        checked: checked,
                                        disabled: item.count === 0,
                                        onChange: function(e) {
                                            return (0,helpers/* handleFilterChange */.G)(e, router, code);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (category_module_default())["input-check-color__box"]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* Check12x9Svg */.zE, {
                                        className: (category_module_default())["input-check-color__icon"]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (category_module_default())["input-check-color__stick"]
                                    })
                                ]
                            })
                        })
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var CustomCategoryPage_CustomFilterColor = (CustomFilterColor);

;// CONCATENATED MODULE: ./components/ForCWV/CustomCategoryPage/CustomWidgetFilters.tsx













var WidgetFilters = function(param) {
    var filters = param.filters, minPrice = param.minPrice, maxPrice = param.maxPrice, translationsData = param.translationsData, selectedRate = param.selectedRate;
    var router = (0,next_router.useRouter)();
    var handleResetFilters = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!router.query.slug) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            router.push("/catalog/".concat(router.query.slug))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            router.push("/catalog")
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleResetFilters() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleColor_ListProps = function(item) {
        var ref = item || {}, attribute_options = ref.attribute_options, tmp = ref.attributes, ref1 = (0,_sliced_to_array/* default */.Z)(tmp === void 0 ? [] : tmp, 1), tmp1 = ref1[0], ref2 = tmp1 === void 0 ? {} : tmp1, _name = ref2.name, name = _name === void 0 ? "" : _name;
        return {
            data: attribute_options,
            value: item,
            title: name
        };
    };
    var handleFilterType = function(item) {
        var ref, ref1;
        return {
            select: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCategoryPage_CustomFilterSelect, (0,_object_spread/* default */.Z)({
                translationsData: translationsData
            }, handleColor_ListProps(item))),
            checkbox: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCategoryPage_CustomFilterCheck, (0,_object_spread/* default */.Z)({}, handleColor_ListProps(item))),
            multiselect: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCategoryPage_CustomFilterMultiSelect, (0,_object_spread/* default */.Z)({
                translationsData: translationsData
            }, handleColor_ListProps(item))),
            color: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCategoryPage_CustomFilterColor, (0,_object_spread/* default */.Z)({}, handleColor_ListProps(item))),
            price: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCategoryPage_CustomFilterRange, {
                data: {
                    min: parseInt(minPrice),
                    max: parseInt(maxPrice)
                },
                title: item === null || item === void 0 ? void 0 : (ref = item.attributes) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.name,
                selectedRate: selectedRate
            })
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: filters.map(function(item) {
            var ref = item || {}, tmp = ref.attributes, ref1 = (0,_sliced_to_array/* default */.Z)(tmp === void 0 ? [] : tmp, 1), tmp1 = ref1[0], ref2 = tmp1 === void 0 ? {} : tmp1, _code = ref2.code, code = _code === void 0 ? "" : _code, _filterType = ref2.filterType, filterType = _filterType === void 0 ? "" : _filterType, _type = ref2.type, type = _type === void 0 ? "" : _type, _id = ref._id;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((category_module_default())["widget-filters"], " ").concat((category_module_default())["widget-filters--offcanvas--mobile"]),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((category_module_default())["widget-filters__list"], " ").concat(code === "color" ? "".concat((category_module_default())["widget-filters__list-colors"], " tablet") : ""),
                        children: handleFilterType(item)[type]
                    }),
                    code === "price" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (category_module_default())["widget-filters__actions"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "btn btn-primary btn-lg ".concat((category_module_default())["btn-widget"]),
                            onClick: handleResetFilters,
                            children: translationsData === null || translationsData === void 0 ? void 0 : translationsData.Reset
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {})
                ]
            }, _id);
        })
    });
};
/* harmony default export */ var CustomWidgetFilters = (WidgetFilters);


/***/ }),

/***/ 49919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ handleFilterChange; },
/* harmony export */   "Z": function() { return /* binding */ optionsHandler; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10092);






var handleFilterChange = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(param, router, code) {
        var _target, targetValue, targetChecked, routerQueryCore, routerPush, routerQuery, filterCode, existFilterCode;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _target = param.target, targetValue = _target.value, targetChecked = _target.checked;
                    routerQueryCore = router.query, routerPush = router.push;
                    routerQuery = routerQueryCore;
                    routerQuery === null || routerQuery === void 0 ? void 0 : delete routerQuery.page;
                    filterCode = routerQuery === null || routerQuery === void 0 ? void 0 : routerQuery["filter_".concat(code)];
                    existFilterCode = function() {
                        var filterArr = null;
                        if (filterCode) filterArr = String(filterCode).split(",");
                        if (targetChecked) {
                            if (filterArr) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, routerQuery), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, "filter_".concat(code), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(filterArr).concat([
                                    targetValue
                                ]).join(",")));
                            }
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, routerQuery), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, "filter_".concat(code), [
                                targetValue
                            ].join(",")));
                        } else {
                            var filteredItem = filterArr === null || filterArr === void 0 ? void 0 : filterArr.filter(function(elem) {
                                return String(elem) !== String(targetValue);
                            });
                            if (filteredItem && (filteredItem === null || filteredItem === void 0 ? void 0 : filteredItem.length) > 0) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, routerQuery), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, "filter_".concat(code), filteredItem.join(",")));
                            }
                            routerQuery === null || routerQuery === void 0 ? void 0 : delete routerQuery["filter_".concat(code)];
                            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, routerQuery);
                        }
                    }();
                    return [
                        4,
                        routerPush({
                            query: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, existFilterCode)
                        }, undefined, {
                            scroll: false
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function handleFilterChange(_, router, code) {
        return _ref.apply(this, arguments);
    };
}();
var optionsHandler = function(translationsData, sortByPrice) {
    var Intl_keys_sortBy = {
        asc: "PriceLowHigh",
        desc: "PriceHighLow",
        default: "Default"
    };
    return {
        attribute_code: translationsData === null || translationsData === void 0 ? void 0 : translationsData.SortBy,
        default_label: translationsData === null || translationsData === void 0 ? void 0 : translationsData[Intl_keys_sortBy[sortByPrice]],
        idKey: Intl_keys_sortBy[sortByPrice],
        field_options: [
            {
                id: 0,
                label: translationsData === null || translationsData === void 0 ? void 0 : translationsData.Default,
                key: "default",
                idKey: "sort_by"
            },
            {
                id: 1,
                label: translationsData === null || translationsData === void 0 ? void 0 : translationsData.PriceLowHigh,
                key: "asc",
                idKey: "price_low_high"
            },
            {
                id: 2,
                label: translationsData === null || translationsData === void 0 ? void 0 : translationsData.PriceHighLow,
                key: "desc",
                idKey: "price_high_low"
            }, 
        ]
    };
};


/***/ }),

/***/ 57707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ForCWV_CustomCategoryPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/ForCWV/CustomCategoryPage/category.module.scss
var category_module = __webpack_require__(14911);
var category_module_default = /*#__PURE__*/__webpack_require__.n(category_module);
// EXTERNAL MODULE: ./components/shared/InfiniteScroll.tsx
var InfiniteScroll = __webpack_require__(92608);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./components/ForCWV/CustomCategoryPage/CustomPagination/pagination.module.scss
var pagination_module = __webpack_require__(85780);
var pagination_module_default = /*#__PURE__*/__webpack_require__.n(pagination_module);
// EXTERNAL MODULE: ./svg/index.js
var svg = __webpack_require__(69587);
;// CONCATENATED MODULE: ./components/ForCWV/CustomCategoryPage/CustomPagination/CustomPagination.tsx










var CustomPagination = function(param) {
    var _total = param.total, total = _total === void 0 ? 1 : _total, getPages = param.getPages;
    var _ref = (0,next_router.useRouter)(), _query = _ref.query, tmp = _query.page, current = tmp === void 0 ? 1 : tmp, routerPush = _ref.push, query = (0,_object_without_properties/* default */.Z)(_ref.query, [
        "page"
    ]);
    var handleClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var setPageVal, condition, _ref, page, queryWithoutPage;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setPageVal = param.setPageVal, condition = param.condition;
                        if (!(Number(setPageVal) === 1)) return [
                            3,
                            2
                        ];
                        _ref = query || {}, page = _ref.page, queryWithoutPage = (0,_object_without_properties/* default */.Z)(_ref, [
                            "page"
                        ]);
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "smooth"
                        });
                        return [
                            4,
                            routerPush({
                                query: queryWithoutPage
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        if (!(Number(setPageVal) !== Number(current) && condition)) return [
                            3,
                            4
                        ];
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "smooth"
                        });
                        return [
                            4,
                            routerPush({
                                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
                                    page: String(setPageVal)
                                })
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClick(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var pageChangeArrow = function(condition, ariaLabel, setPageVal, arrowSide) {
        var svgArrowProps = {
            className: "".concat((pagination_module_default())["page-link__arrow"], " ").concat((pagination_module_default())["page-link__arrow--".concat(arrowSide)]),
            "aria-hidden": "true"
        };
        var svgSideElemHandle = {
            left: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* ArrowRoundedLeft8x13Svg */.lb, (0,_object_spread/* default */.Z)({}, svgArrowProps)),
            right: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* ArrowRoundedRight8x13Svg */.pn, (0,_object_spread/* default */.Z)({}, svgArrowProps))
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
            className: "".concat((pagination_module_default())["page-item"], " ").concat(!condition ? (pagination_module_default())["page-item-disabled"] : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "".concat((pagination_module_default())["page-link"], " ").concat((pagination_module_default())["page-link--with-arrow"]),
                "aria-label": ariaLabel,
                onClick: function() {
                    return handleClick({
                        setPageVal: setPageVal,
                        condition: condition
                    });
                },
                children: svgSideElemHandle[arrowSide]
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: (pagination_module_default()).pagination,
        children: [
            pageChangeArrow(current > 1, "Previous", +current - 1, "left"),
            getPages === null || getPages === void 0 ? void 0 : getPages.map(function(page, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: page === +current ? (pagination_module_default())["page-item-active"] : "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: (pagination_module_default())["page-link"],
                        onClick: function() {
                            return handleClick({
                                setPageVal: page,
                                condition: current !== page
                            });
                        },
                        children: [
                            page,
                            page === +current ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (pagination_module_default())["sr-only"],
                                children: current
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {})
                        ]
                    })
                }, index);
            }),
            pageChangeArrow(current < total, "Next", +current + 1, "right")
        ]
    });
};
/* harmony default export */ var CustomPagination_CustomPagination = (CustomPagination);

;// CONCATENATED MODULE: ./components/ForCWV/CustomCategoryPage/InfiniteContentLayout.tsx





var InfiniteContentLayout = function(param) {
    var isInfinite = param.isInfinite, children = param.children, pageCount = param.pageCount, getPages = param.getPages, isMobile = param.isMobile;
    if (isInfinite) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteScroll/* default */.Z, {
            total: pageCount,
            children: children,
            isMobile: isMobile
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            children,
            pageCount > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    margin: "47px 0"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (category_module_default())["posts-view__pagination"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomPagination_CustomPagination, {
                            total: pageCount,
                            getPages: getPages
                        })
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {})
        ]
    });
};
/* harmony default export */ var CustomCategoryPage_InfiniteContentLayout = (InfiniteContentLayout);

// EXTERNAL MODULE: ./atoms/atoms.module.scss
var atoms_module = __webpack_require__(67191);
var atoms_module_default = /*#__PURE__*/__webpack_require__.n(atoms_module);
;// CONCATENATED MODULE: ./components/ForCWV/CustomCategoryPage/CustomDropdown.tsx




var CustomDropdown = function(param) {
    var _item = param.item, attribute_code = _item.attribute_code, default_label = _item.default_label, field_options = _item.field_options, handleChange = param.handleChange;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var rootRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var handleEvent = function(e) {
            if (rootRef.current && !rootRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleEvent);
        return function() {
            return document.removeEventListener("mousedown", handleEvent);
        };
    }, []);
    var handleClick = function(selectedLabel) {
        handleChange(selectedLabel);
        setOpen(false);
    };
    var displayDropDown = {
        "true": "block",
        "false": "none"
    };
    var openDropDown = {
        "true": (atoms_module_default()).drop_down_opened,
        "false": ""
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (atoms_module_default()).drop_down,
        ref: rootRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (atoms_module_default()).drop_down_btn,
                onClick: function() {
                    return setOpen(function(prevState) {
                        return !prevState;
                    });
                },
                children: [
                    attribute_code,
                    " ",
                    default_label,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* CustomSelectArrow */.xl, {
                        className: "".concat((atoms_module_default()).drop_down_arrow, " ").concat(openDropDown["".concat(open)])
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    display: displayDropDown["".concat(open)]
                },
                className: (atoms_module_default()).drop_down_block,
                children: field_options.map(function(option, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: String(option.id),
                        className: (atoms_module_default()).drop_down_option,
                        onClick: function() {
                            return handleClick(option.key);
                        },
                        children: option.label
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var CustomCategoryPage_CustomDropdown = (CustomDropdown);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(81043);
// EXTERNAL MODULE: ./store/sidebar/index.js + 3 modules
var sidebar = __webpack_require__(73360);
;// CONCATENATED MODULE: ./components/ForCWV/CustomCategoryPage/CustomCategorySidebar.tsx






var CustomCategorySidebar = function(param) {
    var children = param.children, translationsData = param.translationsData;
    var sidebarOpen = (0,es/* useSelector */.v9)(function(state) {
        return state.sidebar.open;
    });
    var bodyRef = (0,react.useRef)(null);
    var dispatch = (0,es/* useDispatch */.I0)();
    var sideBarOpened = {
        "true": (category_module_default())["block-sidebar--open"],
        "false": ""
    };
    var openedSideBarClass = {
        "true": (category_module_default()).open,
        "false": ""
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (category_module_default())["shop-layout__sidebar"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((category_module_default())["block-sidebar"], " ").concat((category_module_default())["block-sidebar--offcanvas--mobile"], " "),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (category_module_default())["block-sidebar__body"],
                ref: bodyRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (category_module_default())["block-sidebar__header"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((category_module_default())["block-sidebar__title"], " ").concat((category_module_default()).tablet),
                            onClick: function() {
                                return dispatch((0,sidebar/* sidebarState */.B)());
                            },
                            children: [
                                translationsData === null || translationsData === void 0 ? void 0 : translationsData.Filters,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "".concat((category_module_default()).filter__item, " ").concat(openedSideBarClass["".concat(sidebarOpen)]),
                                    type: "button",
                                    "aria-label": "Open Product Filter Sidebar",
                                    tabIndex: 0,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* ArrowRoundedDown12x7Svg */.bD, {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((category_module_default())["block-sidebar__item"], " ").concat(sideBarOpened["".concat(sidebarOpen)]),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (category_module_default())["widget-categories"],
                            children: children
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var CustomCategoryPage_CustomCategorySidebar = (CustomCategorySidebar);

// EXTERNAL MODULE: ./components/ForCWV/CustomCategoryPage/CustomWidgetFilters.tsx + 5 modules
var CustomWidgetFilters = __webpack_require__(11802);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./components/ForCWV/Products/ProductCard.tsx
var ProductCard = __webpack_require__(84937);
// EXTERNAL MODULE: ./components/schemaorg/index.tsx
var schemaorg = __webpack_require__(91257);
;// CONCATENATED MODULE: ./components/ForCWV/CustomCategoryPage/CustomProductView.tsx











var ProductsView = function(param) {
    var productsListData = param.productsList, dbName = param.dbName, tmp = param.selectedRate, ref = tmp === void 0 ? {} : tmp, tmp1 = ref.symbol, selectedCurrSymbol = tmp1 === void 0 ? "" : tmp1, tmp2 = ref.exchange_rate, ref1 = tmp2 === void 0 ? {} : tmp2, tmp3 = ref1.rate, selectedCurrRate = tmp3 === void 0 ? "1" : tmp3, tmp4 = ref.code, selectedCurrCode = tmp4 === void 0 ? "" : tmp4, selectedLocale = param.selectedLocale, translationsData = param.translationsData, backOrderValue = param.backOrderValue, _whichOneRender = param.whichOneRender, firstDivClassName = _whichOneRender.firstDivClassName, firstDivParams = _whichOneRender.firstDivParams, secondDivClassName = _whichOneRender.secondDivClassName, showEmptyFiltersSection = _whichOneRender.showEmptyFiltersSection, showElement = _whichOneRender.showElement, isMobile = param.isMobile;
    var router = (0,next_router.useRouter)();
    var schema = (0,schemaorg/* schemaCategoryPage */.Rh)(productsListData, dbName);
    var ref2 = (0,react.useRef)(null);
    var ref3 = (0,react.useState)(false), originalProducts = ref3[0], setOriginalProducts = ref3[1];
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            if (ref2 && ref2.current) {
                setOriginalProducts(window.scrollY >= 80);
            }
        };
        if (!originalProducts && isMobile) {
            window.addEventListener("scroll", handleScroll);
        }
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    var contentHandler = {
        List: (isMobile && !originalProducts ? productsListData.filter(function(_, indexFil) {
            return indexFil < 4;
        }) : productsListData).map(function(product, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (category_module_default())["products-list__item"],
                ref: !originalProducts ? ref2 : null,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, {
                    product: product,
                    dbName: dbName,
                    translationsData: translationsData,
                    backOrderValue: backOrderValue,
                    selectedCurrItems: {
                        selectedCurrCode: selectedCurrCode,
                        selectedCurrRate: selectedCurrRate,
                        selectedCurrSymbol: selectedCurrSymbol
                    },
                    selectedLocale: selectedLocale,
                    priority: index < 2,
                    loading: index < 2 ? "eager" : "lazy"
                })
            }, index);
        }),
        Empty: translationsData === null || translationsData === void 0 ? void 0 : translationsData.NoProductsYet
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: schema.name,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(schema)
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (category_module_default())["products-view"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (category_module_default())["products-view__loader"]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        className: (category_module_default())[firstDivClassName]
                    }, firstDivParams), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (category_module_default())[secondDivClassName],
                                children: contentHandler[showElement]
                            }),
                            showEmptyFiltersSection && Object.keys(router.query).includes("filter") ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "btn btn-orange btn-sm",
                                onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    router.push("/catalog/".concat(router.query.slug))
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }),
                                children: translationsData === null || translationsData === void 0 ? void 0 : translationsData.Reset
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {})
                        ]
                    }))
                ]
            })
        ]
    });
};
/* harmony default export */ var CustomProductView = (ProductsView);

// EXTERNAL MODULE: ./components/builder/BuilderDataRender.tsx + 31 modules
var BuilderDataRender = __webpack_require__(42289);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/ForCWV/CustomCategoryPage/helpers.ts
var helpers = __webpack_require__(49919);
// EXTERNAL MODULE: ./components/shared/PageHeader.tsx
var PageHeader = __webpack_require__(64465);
;// CONCATENATED MODULE: ./components/ForCWV/CustomCategoryPage/index.tsx



















var CustomCategoryPage = function(param) {
    var brandList = param.brandList, _productsList = param.productsList, data = _productsList.data, tmp = _productsList.dispatches, ref = tmp === void 0 ? {} : tmp, _setInitialMaxPrice = ref.setInitialMaxPrice, setInitialMaxPrice = _setInitialMaxPrice === void 0 ? "" : _setInitialMaxPrice, _setInitialMinPrice = ref.setInitialMinPrice, setInitialMinPrice = _setInitialMinPrice === void 0 ? "" : _setInitialMinPrice, isInfiniteScroll = _productsList.isInfiniteScroll, pageCount = _productsList.pageCount, getPages = _productsList.getPages, showCatalog = _productsList.showCatalog, dbName = param.dbName, titleCategory = param.titleCategory, categoryDescription = param.categoryDescription, selectedRate = param.selectedRate, translationsData = param.translationsData, breadcrumb = param.breadcrumb, blockStyleHandle = param.blockStyleHandle, hasFilterInQuery = param.hasFilterInQuery, selectedLocale = param.selectedLocale, backOrderValue = param.backOrderValue, whichOneRender = param.whichOneRender, getBuilderData = param.getBuilderData, showBuilderData = param.showBuilderData, domain = param.domain, currencies = param.currencies, isMobile = param.isMobile, recaptchaActive = param.recaptchaActive;
    var ref1;
    var sidebarOpen = (0,es/* useSelector */.v9)(function(state) {
        return state.sidebar.open;
    }) || false;
    var router = (0,next_router.useRouter)();
    var options = (0,helpers/* optionsHandler */.Z)(translationsData, ((ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.sort_by_price) || "default");
    var _currencies = (0,_sliced_to_array/* default */.Z)(currencies, 1), tmp1 = _currencies[0], ref2 = tmp1 === void 0 ? {} : tmp1, tmp2 = ref2.code, selectedCurrCode = tmp2 === void 0 ? "" : tmp2, tmp3 = ref2.symbol, selectedCurrSymbol = tmp3 === void 0 ? "" : tmp3, tmp4 = ref2.exchange_rate, ref3 = tmp4 === void 0 ? {} : tmp4, tmp5 = ref3.rate, selectedCurrRate = tmp5 === void 0 ? "1" : tmp5;
    var showBuilderComponents = function(id) {
        if (showBuilderData) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderDataRender/* default */.Z, {
                tab: id,
                getBuilderData: getBuilderData,
                domain: domain,
                dbName: dbName,
                translationsData: translationsData,
                selectedLocale: selectedLocale,
                currencies: currencies,
                backOrderValue: backOrderValue,
                selectedCurrItems: {
                    selectedCurrCode: selectedCurrCode,
                    selectedCurrRate: selectedCurrRate,
                    selectedCurrSymbol: selectedCurrSymbol
                },
                isMobile: isMobile,
                recaptchaActive: recaptchaActive
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {});
    };
    var handleChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
            var updatedQuery;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        updatedQuery = router.query;
                        updatedQuery === null || updatedQuery === void 0 ? void 0 : delete updatedQuery.page;
                        if (!(value === "default")) return [
                            3,
                            2
                        ];
                        updatedQuery === null || updatedQuery === void 0 ? void 0 : delete updatedQuery.sort_by_price;
                        return [
                            4,
                            router.push({
                                query: updatedQuery
                            }, {}, {
                                scroll: false
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            router.push({
                                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, updatedQuery), {
                                    sort_by_price: value
                                })
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleChange(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var ShowFilters = function() {
        if (hasFilterInQuery) return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {});
        var filterProps = {
            filters: brandList,
            maxPrice: setInitialMaxPrice,
            minPrice: setInitialMinPrice,
            selectedRate: selectedRate,
            translationsData: translationsData
        };
        if (isMobile) {
            if (sidebarOpen) {
                var CustomWidgetFiltersMobile = dynamic_default()(function() {
                    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 11802));
                }, {
                    loadableGenerated: {
                        webpack: function() {
                            return [
                                /*require.resolve*/(11802)
                            ];
                        }
                    },
                    ssr: false,
                    loading: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {});
                    }
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCategoryPage_CustomCategorySidebar, {
                    translationsData: translationsData,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomWidgetFiltersMobile, (0,_object_spread/* default */.Z)({}, filterProps))
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCategoryPage_CustomCategorySidebar, {
                translationsData: translationsData,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {})
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCategoryPage_CustomCategorySidebar, {
            translationsData: translationsData,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomWidgetFilters["default"], (0,_object_spread/* default */.Z)({}, filterProps))
        });
    };
    var ShowDropDown = function() {
        if (data.length > 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((category_module_default())["products-list__body"], " ").concat((category_module_default()).products_sort),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCategoryPage_CustomDropdown, {
                    item: options,
                    handleChange: handleChange,
                    translationsData: translationsData
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {});
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "site_category_page",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                dbName: dbName,
                breadcrumb: breadcrumb
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomCategoryPage_InfiniteContentLayout, {
                isInfinite: isInfiniteScroll,
                pageCount: pageCount,
                getPages: getPages,
                isMobile: isMobile,
                children: [
                    showBuilderComponents(1),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (category_module_default()).category_components_wrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (category_module_default())[blockStyleHandle],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (category_module_default())["category-title"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            children: titleCategory
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        dangerouslySetInnerHTML: {
                                            __html: categoryDescription
                                        },
                                        className: (category_module_default())["category-description"]
                                    }),
                                    showBuilderComponents(2),
                                    showCatalog ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (category_module_default())["shop-layout"],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowFilters, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (category_module_default())["shop-layout__content"],
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowDropDown, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomProductView, {
                                                        productsList: data,
                                                        dbName: dbName,
                                                        selectedRate: selectedRate,
                                                        selectedLocale: selectedLocale,
                                                        backOrderValue: backOrderValue,
                                                        translationsData: translationsData,
                                                        whichOneRender: whichOneRender,
                                                        isMobile: isMobile
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : null
                                ]
                            })
                        })
                    })
                ]
            }),
            showBuilderComponents(3)
        ]
    });
};
/* harmony default export */ var ForCWV_CustomCategoryPage = (CustomCategoryPage);


/***/ }),

/***/ 92608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);






var InfiniteScroll = function(param) {
    var children = param.children, total = param.total, isMobile = param.isMobile;
    var _ref = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(), _query = _ref.query, tmp = _query.page, current = tmp === void 0 ? 1 : tmp, routerPush = _ref.push, asPath = _ref.asPath, query = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref.query, [
        "page"
    ]);
    var sentinelRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var observerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handleIntersection = function(entries) {
            var entry = entries[0];
            if (entry.isIntersecting) {
                var currPageHandle = function() {
                    if (!current) return "2";
                    var finalPage = +current >= +total;
                    if (!finalPage) return String(+current + 1);
                    return String(current);
                };
                if (+current <= +total && currPageHandle() !== "1") {
                    routerPush({
                        query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, query), {
                            page: currPageHandle()
                        })
                    }, undefined, {
                        scroll: false,
                        shallow: false
                    });
                }
            }
        };
        observerRef.current = new IntersectionObserver(handleIntersection, {
            root: null,
            rootMargin: isMobile ? "600px" : "900px"
        });
        if (sentinelRef.current) {
            observerRef.current.observe(sentinelRef.current);
        }
        return function() {
            if (observerRef.current && sentinelRef.current) {
                observerRef.current.unobserve(sentinelRef.current);
            }
        };
    }, [
        current,
        total,
        query,
        routerPush
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: sentinelRef
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InfiniteScroll);


/***/ }),

/***/ 64465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69587);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12820);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_shared_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _schemaorg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91257);








var PageHeader = function(props) {
    var _breadcrumb = props.breadcrumb, breadcrumb = _breadcrumb === void 0 ? [] : _breadcrumb, dbName = props.dbName;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var schema = (0,_schemaorg__WEBPACK_IMPORTED_MODULE_6__/* .schemaPageHeader */ .ed)(dbName, router.asPath, breadcrumb);
    if (breadcrumb.length > 0) {
        var lastIndex = breadcrumb.length - 1;
        breadcrumb = breadcrumb.map(function(item, index) {
            var link;
            if (lastIndex === index) {
                link = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_5___default()), {
                            id: schema.name,
                            type: "application/ld+json",
                            dangerouslySetInnerHTML: {
                                __html: JSON.stringify(schema)
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item-active"])),
                            "aria-current": "page",
                            children: item.title
                        })
                    ]
                }, index);
            } else {
                link = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: item.url,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: item.title
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .ArrowRoundedRight6x9Svg */ .EO, {
                            className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-arrow"])
                        })
                    ]
                }, index);
            }
            return link;
        });
        breadcrumb = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header__breadcrumb"]),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                "aria-label": "breadcrumb",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                    className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default().breadcrumb),
                    children: breadcrumb
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header__container"]), " container"),
            children: breadcrumb
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageHeader);


/***/ }),

/***/ 2598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_recaptcha_v3__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69498);



var ReCaptchaWrapper = function(param) {
    var children = param.children, recaptchaActive = param.recaptchaActive, recaptchaKey = param.recaptchaKey;
    if (!+recaptchaActive) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: children
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_recaptcha_v3__WEBPACK_IMPORTED_MODULE_2__/* .ReCaptchaProvider */ .dR, {
        useEnterprise: true,
        reCaptchaKey: recaptchaKey,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReCaptchaWrapper);


/***/ }),

/***/ 67191:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"select_global":"atoms_select_global__9eedR","toasts-wrapper":"atoms_toasts-wrapper__f9E7x","toast":"atoms_toast__c1BL3","toast-in-right":"atoms_toast-in-right__oeYsw","toast__text":"atoms_toast__text__EPBnn","toast__close-btn":"atoms_toast__close-btn__dMM0t","custom_textArea_checkout":"atoms_custom_textArea_checkout__07AIE","custom_textarea":"atoms_custom_textarea__bxfYq","custom_input_label":"atoms_custom_input_label__dMW0i","custom_input_field":"atoms_custom_input_field__8JhNw","red-fms":"atoms_red-fms__gy8KO","custom_input_checkout":"atoms_custom_input_checkout__QDlqs","err_field":"atoms_err_field__aGr7k","signUp-position-relative":"atoms_signUp-position-relative__Q1wgP","form-group":"atoms_form-group__lbJzQ","input-paddings":"atoms_input-paddings__WnO_x","signUp-position-radio-flex":"atoms_signUp-position-radio-flex___S_MV","signUp-position-no-input":"atoms_signUp-position-no-input__7Zhfu","custom_multiselect":"atoms_custom_multiselect__xCPeT","open":"atoms_open__499_m","custom_select-button":"atoms_custom_select-button__R9Agp","custom_multiselect-arrow":"atoms_custom_multiselect-arrow__e_Dc6","custom_multiselect-drop_down":"atoms_custom_multiselect-drop_down__yTDyD","custom_multiselect-button":"atoms_custom_multiselect-button__xacoC","custom_multiselect-button_selected":"atoms_custom_multiselect-button_selected__lOZW7","selected_del_btn":"atoms_selected_del_btn__kgNNw","custom_multiselect-option":"atoms_custom_multiselect-option__TbKPh","selected_option":"atoms_selected_option__C10_7","signUp-position-yes-no":"atoms_signUp-position-yes-no__kakyJ","signUp-position-yes-input":"atoms_signUp-position-yes-input__wAo2f","drop_down":"atoms_drop_down__oFda3","drop_down_btn":"atoms_drop_down_btn__ZShbQ","drop_down_arrow":"atoms_drop_down_arrow__CX3gx","drop_down_opened":"atoms_drop_down_opened___THG_","drop_down_block":"atoms_drop_down_block__ZrZ9T","drop_down_option":"atoms_drop_down_option__KFMWc","select_wrapper":"atoms_select_wrapper__pzpP1","select_label_title":"atoms_select_label_title__FkHzd","select_asterisk":"atoms_select_asterisk__ycLWy","select_container":"atoms_select_container__xwpkP","select_width":"atoms_select_width__GyLl1","caret_wrapper":"atoms_caret_wrapper__GSM1Z"};

/***/ }),

/***/ 85780:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page-item-disabled":"pagination_page-item-disabled__ZuCMi","page-link":"pagination_page-link__FHB_2","page-link--with-arrow":"pagination_page-link--with-arrow__EzUDL","page-link__arrow":"pagination_page-link__arrow__K2R0W","page-link__arrow--left":"pagination_page-link__arrow--left__CogKS","page-link__arrow--right":"pagination_page-link__arrow--right__nNpnK","page-item":"pagination_page-item__u6Pdt","page-item-active":"pagination_page-item-active__Bkoe4","pagination":"pagination_pagination__cg_PA","sr-only":"pagination_sr-only__ywdBa"};

/***/ }),

/***/ 14911:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"category_components_wrapper":"category_category_components_wrapper__SKuBi","empty_block":"category_empty_block__Nqzux","shop-layout":"category_shop-layout__jkaNw","shop-layout__content":"category_shop-layout__content__wpGT4","full_block":"category_full_block___cash","category-title":"category_category-title__OHgKO","category-description":"category_category-description__Xsz3h","shop-layout__sidebar":"category_shop-layout__sidebar__Alfl3","block-sidebar":"category_block-sidebar__Wq_HB","block-sidebar__body":"category_block-sidebar__body__y4qPj","block-sidebar__header":"category_block-sidebar__header__Gx9AK","block-sidebar__item":"category_block-sidebar__item__QtL13","widget-categories":"category_widget-categories__1LPz5","widget-filters":"category_widget-filters__rA2W8","widget-filters__list":"category_widget-filters__list__QRs8_","filter-list":"category_filter-list__RkJMI","checkbox__item":"category_checkbox__item__cdeD7","input-check__box":"category_input-check__box__yFs5M","multiselect__title":"category_multiselect__title__ds9oG","select__title":"category_select__title__BXV6z","select__filter":"category_select__filter__NZkZw","placeholder":"category_placeholder__aVR46","selected__item":"category_selected__item__w46pN","select_filter__options":"category_select_filter__options__vaAd8","selected__option":"category_selected__option__0614z","widget__title":"category_widget__title__DRCBi","widget__field":"category_widget__field__lr9P0","filter__item":"category_filter__item__T0VNH","open":"category_open__VvfSH","selected__items":"category_selected__items__Qn9D2","filter-multiselect__list":"category_filter-multiselect__list__jvmvm","filter-select__list":"category_filter-select__list__aCMxa","filter-list__item":"category_filter-list__item__fFDS_","filter-list__list":"category_filter-list__list__UP_zm","multiselect__item":"category_multiselect__item__ad6hC","filter-list__input":"category_filter-list__input__a0CUX","filter-list__title":"category_filter-list__title__O9o4y","input-check__body":"category_input-check__body__ASRoD","input-check__input":"category_input-check__input__AFzfY","input-check__icon":"category_input-check__icon__kVOad","widget-filters__list-colors":"category_widget-filters__list-colors__I9TUV","filter-color__list":"category_filter-color__list__YKbEP","filter-color__item":"category_filter-color__item__kFXp0","input-check-color":"category_input-check-color__1Ree1","input-check-color--white":"category_input-check-color--white__cS8_C","input-check-color__box":"category_input-check-color__box__t8Cv5","input-check-color__icon":"category_input-check-color__icon__Dw0nx","input-check-color__body":"category_input-check-color__body__x7nqh","input-check-color__input":"category_input-check-color__input__A0wXf","input-check-color__stick":"category_input-check-color__stick__V59WG","filter-price":"category_filter-price__0Fe4I","filter-price__title":"category_filter-price__title__QKFYS","filter-price__min-value":"category_filter-price__min-value__DK5H0","filter-price__max-value":"category_filter-price__max-value__unJUm","filter-price__slider":"category_filter-price__slider__oKJwU","same_min_max":"category_same_min_max__MDS79","filter-price__inputs":"category_filter-price__inputs__q9wxa","input__container":"category_input__container__eacxe","widget-filters__actions":"category_widget-filters__actions___xAnV","btn-widget":"category_btn-widget__ue2Nq","full":"category_full__f_BeA","products-list__body":"category_products-list__body__wqYCS","products_sort":"category_products_sort__P4dJd","products-list__item":"category_products-list__item__vW017","products-view":"category_products-view__eItR1","products-view__empty":"category_products-view__empty__NlCF0","products-view__empty-title":"category_products-view__empty-title__dtKnG","block-sidebar__title":"category_block-sidebar__title__BOcVz","block-sidebar--open":"category_block-sidebar--open__1gDcT","mobile-links__item-arrow":"category_mobile-links__item-arrow__Jhf_5","hidden":"category_hidden__n2wKb","multiselect__list":"category_multiselect__list__DMMiw","filter-list__closed":"category_filter-list__closed__JBwDM"};

/***/ })

}]);